import script from "./TrackMotion.vue?vue&type=script&setup=true&lang=js"
export * from "./TrackMotion.vue?vue&type=script&setup=true&lang=js"

import "./TrackMotion.vue?vue&type=style&index=0&id=61b0da8a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61b0da8a"]])

export default __exports__